(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["keeper-fabric-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('keeper-fabric-selector')) {
    customElements.define(
      'keeper-fabric-selector',
      class KeeperFabricSelector extends HTMLElement {
        connectedCallback() {
          this.units = 1;

          this.decreaseButton = this.querySelector(
            '[data-keeper-decrease]'
          );

          this.increaseButton = this.querySelector(
            '[data-keeper-increase]'
          );

          this.cutSelect = this.querySelector(
            '[data-keeper-select]'
          );

          this.priceDisplay = this.querySelector(
            '[data-keeper-price]'
          );

          this.regularPriceDisplay = this.querySelector(
            '[data-keeper-regular-price]'
          );

          this.cutProperty = this.querySelector(
            '[data-keeper-cut-property]'
          );

          this.cartMessage = this.querySelector(
            '[data-keeper-cart-message]'
          );

          this.availability = this.querySelector(
            '[data-keeper-availability]'
          );

          this.decreaseButton?.addEventListener('click', () => {
            if (this.units <= 1) return;
            this.setUnits(this.units - 1);
          });

          this.increaseButton?.addEventListener('click', () => {
            const maxUnits = this.getEffectiveMaxUnits();

            if (maxUnits > 0 && this.units >= maxUnits) {
              const maxLabel =
                this.getMeasurementLabelForUnits(maxUnits);

              this.showAvailabilityMessage(
                `Only ${maxLabel} is currently available.`
              );

              return;
            }

            this.setUnits(this.units + 1);
          });

          this.buildCutOptions();

          this.cutSelect?.addEventListener('change', () => {
            const requestedUnits = Number(this.cutSelect.value);
            const maxUnits = this.getEffectiveMaxUnits();

            if (maxUnits > 0 && requestedUnits > maxUnits) {
              const maxLabel =
                this.getMeasurementLabelForUnits(maxUnits);

              this.showAvailabilityMessage(
                `Only ${maxLabel} is currently available.`
              );

              this.cutSelect.value = String(this.units);
              return;
            }

            this.setUnits(requestedUnits);
          });

          this.setupCartLimitMessage();

          this.updateDisplay();

          setTimeout(() => {
            this.buildCutOptions();
            this.updateDisplay();
          }, 500);
        }

        getEffectiveMaxUnits() {
          const quantityInput = this.getQuantityInput();

          if (quantityInput) {
            const inputMax = Number(quantityInput.getAttribute('max'));

            if (Number.isFinite(inputMax) && inputMax > 0) {
              return inputMax;
            }
          }

          if (this.inventoryIsLimited()) {
            const shopifyMax = this.getMaxUnits();

            if (shopifyMax > 0) {
              return shopifyMax;
            }
          }

          return 0;
        }

        buildCutOptions() {
          if (!this.cutSelect) return;

          const maxUnits = this.getEffectiveMaxUnits();

          if (maxUnits > 0) {
            Array.from(this.cutSelect.options).forEach((option) => {
              if (Number(option.value) > maxUnits) {
                option.remove();
              }
            });
          }

          this.cutSelect.value = String(this.units);
        }

        getProductForm() {
          const productContainer =
            this.closest('.product-information') ||
            this.closest('[data-product-id]') ||
            document;

          const quantityInput = this.getQuantityInput();

          return quantityInput?.form ||
            productContainer.querySelector('form[action*="/cart/add"]');
        }

        getVariantId() {
          return Number(this.dataset.variantId || 0);
        }

        async getCartVariantQuantity() {
          const variantId = this.getVariantId();

          if (!variantId) return 0;

          try {
            const response = await fetch('/cart.js', {
              credentials: 'same-origin',
              headers: {
                Accept: 'application/json'
              }
            });

            if (!response.ok) return 0;

            const cart = await response.json();

            return cart.items
              .filter((item) => Number(item.variant_id) === variantId)
              .reduce((total, item) => total + Number(item.quantity || 0), 0);
          } catch (error) {
            return 0;
          }
        }

        showCartLimitMessage(requestedUnits, addedUnits) {
          if (!this.cartMessage) return;

          const requestedLabel =
            this.getMeasurementLabelForUnits(requestedUnits);

          const addedLabel =
            this.getMeasurementLabelForUnits(addedUnits);

          this.cartMessage.textContent =
            `You selected ${requestedLabel}, but only ${addedLabel} was available. ${addedLabel} was added to your cart.`;

          this.cartMessage.hidden = false;
        }

        clearCartLimitMessage() {
          if (!this.cartMessage) return;

          this.cartMessage.textContent = '';
          this.cartMessage.hidden = true;
        }

        async checkCartAfterAdd(beforeQuantity, requestedUnits) {
          const delays = [350, 700, 1200, 1800, 2600];

          for (const delay of delays) {
            await new Promise((resolve) => setTimeout(resolve, delay));

            const afterQuantity =
              await this.getCartVariantQuantity();

            if (afterQuantity > beforeQuantity) {
              const addedUnits =
                afterQuantity - beforeQuantity;

              if (addedUnits < requestedUnits) {
                this.showCartLimitMessage(
                  requestedUnits,
                  addedUnits
                );
              } else {
                this.clearCartLimitMessage();
              }

              return;
            }
          }
        }

        setupCartLimitMessage() {
          const form = this.getProductForm();

          if (!form || form.dataset.keeperLimitMessageBound === 'true') {
            return;
          }

          form.dataset.keeperLimitMessageBound = 'true';

          form.addEventListener('submit', async () => {
            const requestedUnits = this.units;
            const beforeQuantity =
              await this.getCartVariantQuantity();

            this.clearCartLimitMessage();

            this.checkCartAfterAdd(
              beforeQuantity,
              requestedUnits
            );
          });
        }

        inventoryIsLimited() {
          return this.dataset.limitInventory === 'true';
        }

        getMaxUnits() {
          return Number(this.dataset.maxUnits || 0);
        }

        setUnits(units) {
          let nextUnits = Math.max(1, units);
          const maxUnits = this.getEffectiveMaxUnits();

          if (maxUnits > 0) {
            nextUnits = Math.min(nextUnits, maxUnits);
          }

          this.units = nextUnits;
          this.updateDisplay();
        }

        showAvailabilityMessage(message) {
          if (!this.availability) return;

          this.availability.textContent = message;
        }

        getMeasurementLabelForUnits(units) {
          const wholeYards = Math.floor(units / 4);
          const remainder = units % 4;

          const fractions = {
            0: '',
            1: '¼',
            2: '½',
            3: '¾'
          };

          let measurement = '';

          if (wholeYards > 0) {
            measurement = String(wholeYards);
          }

          if (remainder > 0) {
            measurement += measurement
              ? ` ${fractions[remainder]}`
              : fractions[remainder];
          }

          const yardWord = units <= 4 ? 'yard' : 'yards';

          return `${measurement} ${yardWord}`;
        }

        getMeasurementLabel() {
          return this.getMeasurementLabelForUnits(this.units);
        }

        getQuantityInput() {
          const productContainer =
            this.closest('.product-information') ||
            this.closest('[data-product-id]') ||
            document;

          return productContainer.querySelector(
            'form[action*="/cart/add"] input[name="quantity"]'
          );
        }

        formatMoney(cents) {
          const currency = this.dataset.currency || 'USD';

          return new Intl.NumberFormat(undefined, {
            style: 'currency',
            currency
          }).format(cents / 100);
        }

        updateDisplay() {
          const label = this.getMeasurementLabel();

          const unitPrice = Number(
            this.dataset.variantPrice || 0
          );

          const regularUnitPrice = Number(
            this.dataset.regularPrice || 0
          );

          const quantityInput = this.getQuantityInput();

          if (this.cutSelect) {
            this.cutSelect.value = String(this.units);
          }

          if (this.priceDisplay) {
            this.priceDisplay.textContent = this.formatMoney(
              unitPrice * this.units
            );
          }

          if (this.regularPriceDisplay) {
            this.regularPriceDisplay.textContent = this.formatMoney(
              regularUnitPrice * this.units
            );
          }

          if (this.cutProperty) {
            this.cutProperty.value = label;
          }

          if (quantityInput) {
            quantityInput.value = this.units;

            quantityInput.dispatchEvent(
              new Event('change', { bubbles: true })
            );
          }

          const atMinimum = this.units <= 1;

          if (this.decreaseButton) {
            this.decreaseButton.setAttribute(
              'aria-disabled',
              atMinimum ? 'true' : 'false'
            );

            this.decreaseButton.classList.toggle(
              'keeper-fabric-selector__button--blocked',
              atMinimum
            );
          }

          const maxUnits = this.getEffectiveMaxUnits();

          if (maxUnits > 0) {
            const atMaximum = this.units >= maxUnits;

            if (this.increaseButton) {
              this.increaseButton.setAttribute(
                'aria-disabled',
                atMaximum ? 'true' : 'false'
              );

              this.increaseButton.classList.toggle(
                'keeper-fabric-selector__button--blocked',
                atMaximum
              );
            }

            if (this.availability) {
              const maxLabel =
                this.getMeasurementLabelForUnits(maxUnits);

              this.availability.textContent =
                `${maxLabel} available`;
            }
          } else {
            if (this.increaseButton) {
              this.increaseButton.setAttribute(
                'aria-disabled',
                'false'
              );

              this.increaseButton.classList.remove(
                'keeper-fabric-selector__button--blocked'
              );
            }

            if (this.availability) {
              this.availability.textContent = '';
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
